const currentClassNameTab = 'w--current';
const currentClassNameContent = 'w--tab-active';

export default class WebflowTabs {
    container: null | HTMLElement;
    scrolling = true;
    constructor(tabsId: string, scrolling = true) {
        this.container = document.querySelector(`#${tabsId}`) || null;
        this.scrolling = scrolling;
    }

    open(name: string) {
        const [tab, content] = Array.from(
            this.container.querySelectorAll(`[data-w-tab="${name}"]`)
        );

        if (!tab || !content) return;

        this.container
            ?.querySelectorAll(`.${currentClassNameTab}`)
            .forEach((el) => this.removeTabSelected(el));

        this.container
            ?.querySelectorAll(`.${currentClassNameContent}`)
            .forEach((el) => this.removeContentSelected(el));

        this.selectTab(tab);
        this.selectContent(content);

        // webflow has own logic swiching tabs witch cache last selected so if is that opportunity we want to use manual click
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        tab?.click?.();
        if (this.scrolling) content.scrollIntoView({ behavior: 'smooth' });
    }

    private removeContentSelected(el: Element) {
        el.classList.remove(currentClassNameContent);
    }
    private selectContent(el: Element) {
        el.classList.add(currentClassNameContent);
    }
    private selectTab(el: Element) {
        el.classList.add(currentClassNameTab);
        el.setAttribute('aria-selected', 'true');
    }
    private removeTabSelected(el: Element) {
        el.classList.remove(currentClassNameTab);
        el.setAttribute('aria-selected', 'false');
    }
}
